import { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Grid,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import CreateIcon from "../Assets/create-icon.svg";
import { useQuery } from "@apollo/client";
import moment from "moment";
//src
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import EmptyData from "../Components/Include/EmptyData";
import StudentRentAction from "../Components/StudentRent/StudentRentAction";
import {
  SelectAcademicYear,
  SelectStudent,
  SelectStudentByAcademicYear,
} from "../Components/Include/DynamicSelect";
import CreateStudentRent from "../Components/StudentRent/CreateStudentRent";
import { GET_RENT_MATERIAL_PAGINATION } from "../Schema/StudentRent";
import UpdateStatusRent from "../Components/StudentRent/UpdateStatusRent";

export default function StudentRentBook() {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  // const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [returnStatus, setReturnStatus] = useState("all");

  const [openCreate, setOpenCreate] = useState(false);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  //==================== ====================
  const { refetch } = useQuery(GET_RENT_MATERIAL_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      returnStauses: returnStatus === "all" ? [] : [returnStatus],
      academicYearId: academicYearVal?.id ? academicYearVal.id : "",
      studentId: studentVal?.id ? studentVal.id : "",
    },
    onCompleted: ({ getRentMaterialPagination }) => {
      // console.log("getRentMaterialPagination::", getRentMaterialPagination);
      setTableData(getRentMaterialPagination?.data);
      setPaginationData(getRentMaterialPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::getRentMaterialPagination", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    setLoading(true);
    refetch();
  }, [studentVal?.id, returnStatus, page, limit]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">សម្ភារៈសិស្សជួល</Typography>
        </Stack>
      </Stack>
      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className="search-field"
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">សិស្ស</Typography>
            <SelectStudentByAcademicYear
              selectedVal={studentVal}
              setSelectedVal={setStudentVal}
              academicYearId={academicYearVal?.id}
              disabled={academicYearVal?.id ? false : true}
              className="search-field"
            />
          </Grid>

          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="field-title">ស្ថានភាព</Typography>
            <FormControl fullWidth size="small" className="search-field">
              <Select
                value={returnStatus}
                onChange={(val) => setReturnStatus(val.target.value)}
              >
                <MenuItem value="all">ទាំងអស់</MenuItem>
                <MenuItem value="not_yet_returned">មិនទាន់ប្រគល់</MenuItem>
                <MenuItem value="lose_some">បាត់</MenuItem>
                <MenuItem value="return_some">ប្រគល់ខ្លះ</MenuItem>
                <MenuItem value="return">ប្រគល់អស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Box flexGrow={1} />

          <Grid item xs={6} sm={12} md={12} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpenCreate}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>

            {openCreate && (
              <CreateStudentRent
                open={openCreate}
                handleClose={handleCloseCreate}
                setRefetch={refetch}
              />
            )}
          </Grid>
        </Grid>
      </Box>
      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell className="header-title-start" width="6%">
                  ល.រ
                </TableCell>
                <TableCell className="header-title" width="15%">
                  កាលបរិច្ឆេទជួល
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ឈ្មោះសិស្ស
                </TableCell>
                <TableCell className="header-title" width="15%">
                  អ្នកប្រគល់
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ស្ថានភាព
                </TableCell>
                <TableCell className="header-title" width="15%">
                  ផ្សេងៗ
                </TableCell>
                <TableCell className="header-title-end" width="26%"></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={7} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={7} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      // console.log("row::", row);
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {moment(row?.dateTime)?.format("DD-MM-YYYY")}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.studentId?.firstName +
                                " " +
                                row?.studentId?.lastName}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.createdBy?.mainUserId?.firstName +
                                " " +
                                row?.createdBy?.mainUserId?.lastName}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <UpdateStatusRent row={row} setRefetch={refetch} />
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.remark}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <StudentRentAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>

      {/* ========================= Pagination ============================= */}
      <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      />
    </div>
  );
}
